import Image from 'next/image';

import {Card, Text} from '#component/base';
import {sprinkles} from '#style/sprinkles';

import {LeftTileProps} from './LeftTile.types';

import * as css from './LeftTile.css';

export const LeftTile = ({
  fullWidth,
  mediaSrc,
  mediaType,
  primaryText,
  secondaryText,
  tertiaryText,
}: LeftTileProps) => (
  <Card className={css.root} variant="apricot">
    {mediaType === 'image' && (
      <div className={css.imageContainer({fullWidth})}>
        <Image src={mediaSrc} alt="" layout="fill" objectFit="cover" />
      </div>
    )}

    {mediaType === 'video' && (
      <div
        className={sprinkles({
          content: ['start', 'between', 'start'],
          dir: ['row', 'row', 'colReverse'],
          flex: 'flex',
          gap: [0, 0, 32],
          items: 'center',
          pT: [16, 48, 48],
          pB: [16, 48, 48],
          pR: [0, 48, 48],
          pL: [48],
          pos: 'relative',
          size: 'full',
        })}>
        <div className={css.textContainer}>
          <Text color="paleOrange" fontWeight="semiBold">
            {primaryText}
          </Text>
          <Text color="white" variant="heading2">
            {secondaryText}
          </Text>
          <Text className={css.tertiaryText} color="paleOrange" fontWeight="semiBold">
            {tertiaryText}
          </Text>
        </div>

        <video loop={true} playsInline autoPlay={true} muted className={css.video}>
          <source src={mediaSrc} type="video/mp4" />
        </video>
      </div>
    )}
  </Card>
);
